import template from './homeLoanRefinanceAnalysis.template.html';

export default {
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      eventService,
      authenticationService,
      dateTimeService,
      helperService,
      quickToolService,
      accountService,
      lendersService,
      RefinanceAnalysis,
      pdfService
    ) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.hasBrokerToolsEnabled = false;

      ctrl.initialize = () => {
        ctrl.hasBrokerToolsEnabled = ctrl.isAuthenticated
          ? $rootScope.hasBrokerToolsEnabled()
          : false;

        ctrl.destroyWatch = eventService.onQuickToolHomeLoanRefinanceAnalysis((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {},
              template,
              controllerAs: '$ctrl',
              controller() {
                const ctr = this;
                ctr.isReady = false;
                ctr.isDownloadPreparing = false;
                ctr.isViewPreparing = false;
                ctr.currentAccount = $rootScope.CurrentAccount;
                ctr.currentOrganization = $rootScope.CurrentOrganization;
                ctr.organizationCountry = helperService.getOrganizationCountry().cca2;
                ctr.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
                ctr.currentTimeZone = $rootScope.CurrentTimeZone();
                ctr.currentLocale = $rootScope.CurrentLocale();
                ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                ctr.currentCurrency = $rootScope.CurrentCurrency();
                ctr.lenders = [];
                ctr.refinanceAnalysis = RefinanceAnalysis.Blank();
                ctr.refinanceAnalysis.isEdit = true;

                $q.all([
                  accountService.readAccount({ id: ctr.currentAccount.id }),
                  lendersService.getAvailable({
                    cca2: [ctr.organizationCountry],
                    type: 'RESIDENTIAL'
                  })
                ]).then((data) => {
                  const account = data[0];
                  ctr.isBroker = authenticationService.isBroker(account.id);
                  ctr.idLenderAccreditations = _.compact(
                    account.lenderAccreditations.map((l) => l.idLender)
                  );
                  if (data[1] && data[1].length && ctr.idLenderAccreditations.length) {
                    ctr.lenders = data[1].filter(
                      (l) => ctr.idLenderAccreditations.indexOf(l.id) > -1
                    );
                  }
                  ctr.hasHomeLoanTools =
                    ctr.hasBrokerToolsEnabled && ctr.isBroker && ctr.lenders.length;
                  ctr.isReady = true;

                  ctr.saveRefinanceAnalysis = (refinanceAnalysis) => {
                    ctr.refinanceAnalysis = refinanceAnalysis;
                  };

                  ctr.createPdf = (isView) => {
                    if (isView) {
                      ctr.isViewPreparing = true;
                    } else {
                      ctr.isDownloadPreparing = true;
                    }
                    pdfService
                      .createPdf({
                        refinanceAnalysis: ctr.refinanceAnalysis,
                        pdfType: helperService.getAvailablePdfTypes()[5],
                        isQuickTool: true,
                        isView
                      })
                      .then(() => {
                        if (isView) {
                          ctr.isViewPreparing = false;
                        } else {
                          ctr.isDownloadPreparing = false;
                        }
                      });
                  };
                });
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
